import * as Yup from "yup";
import { useFormik, Form, Field, ErrorMessage } from 'formik';





const UseCustomFormik = (step,data) => {



  const ValidationSchemaArray = [
    Yup.object({
      NIC:Yup.string().required("*Required").test('','NIC does not exists',(val)=>{
        if (data) {
          const exist = data.find((item) => {
            return item.nic === val;
          });
          
      
         if(!exist){
          return false
         }
         else{
          return true
         }
        }

   
       
      }),
      Mobile:Yup.string().required("*Required").max(10,"Invalid Mobile Number").min(10,"Invalid Mobile Number").test('','mobile number does not match',(val)=>{
        if (data) {
          const exist = data.find((item) => {
            return item.nic === formik.values.NIC;
          });
     
        
          
          if(exist){
            if (exist.mobile==val){
             return true;
     
            }
            else{
             return false;
            }
     
            }
        }
      
   
       
      }),
     

    }),

  ]
  const formik = useFormik({
    initialValues: {
      NIC:sessionStorage.getItem('StaffTempNIC')||"",
      Mobile:sessionStorage.getItem('StaffTempMobile')||"",
     
   


    },
    validationSchema: ValidationSchemaArray[(step - 1)]
    ,

  });


  return formik;

}


export default UseCustomFormik;